import React, { useMemo } from "react";
import { DataTable } from "../../../shared/ui/DataTable";
import { Shimmer } from "../../../shared/ui";
import { createTransactionColumns } from "./transactionColumns";
import { TransactionItem } from "../types";

export interface TransactionsTableProps {
  data: TransactionItem[];
  isLoading: boolean;
  copiedId: string | null;
  onCopyId: (e: React.MouseEvent, id: string) => void;
  onRowClick: (item: TransactionItem) => void;
  isOtcTab?: boolean;
}

export const TransactionsTable: React.FC<TransactionsTableProps> = ({
  data,
  isLoading,
  copiedId,
  onCopyId,
  onRowClick,
  isOtcTab = false,
}) => {
  const columns = useMemo(
    () =>
      createTransactionColumns({
        copiedId,
        onCopyId,
        isOtcTab,
      }),
    [copiedId, onCopyId, isOtcTab]
  );

  return (
    <DataTable
      columns={columns}
      data={isLoading ? [] : data}
      getRowKey={(trx, index) =>
        trx._id || trx.TransactionReference || trx.RequestReference || String(index)
      }
      onRowClick={onRowClick}
      className="mt-4"
      emptyState={
        isLoading ? (
          <div className="space-y-3 py-2">
            {Array.from({ length: 6 }).map((_, index) => (
              <Shimmer key={index} className="h-8 w-full rounded-[10px]" />
            ))}
          </div>
        ) : (
          <div className="py-12 text-center text-[14px] text-[#667085]">
            No transactions found for the selected criteria.
          </div>
        )
      }
    />
  );
};

export default TransactionsTable;
